import StaticBuilderModalEnum from 'StaticBuilderModals/StaticBuilderModalConstants';

const openStaticSecondActionModal = () => (dispatch) => {
  dispatch({
    type: StaticBuilderModalEnum.OPEN_STATIC_SECOND_ACTION_MODAL,
  });
};

export default openStaticSecondActionModal;



// WEBPACK FOOTER //
// ./src-react/StaticBuilderModals/actions/openStaticSecondActionModal.jsx